var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.dialogs),function(dialog){return _c(dialog.component,_vm._g(_vm._b({key:dialog.id,tag:"component",attrs:{"value":dialog.state}},'component',_vm.extendAttrs(dialog),false),_vm.extendListeners(dialog)))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }